module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.backToUser
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_vm._v("User Form")]), _vm._v(" "), (this.UserPersonalDetail.userId != '' || this.clientModal.userId != '') ? _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Delete User")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(this.UserPersonalDetail.userId != '' || this.clientModal.userId != '') ? _c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "info",
      "size": "sm"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset Password")])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "dialog2",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "id": "myDIV",
      "hide-footer": "",
      "title": "Password Reset Utility"
    }
  }, [_c('b-card', [_c('b-card-text', [_c('b-form', [_c('div', [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("no_encryption")])], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Password"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "newPassword", $$v)
      },
      expression: "PasswordModal.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("no_encryption")])], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password",
      "required": "",
      "placeholder": "Confirm Password"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.confPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "confPassword", $$v)
      },
      expression: "PasswordModal.confPassword"
    }
  })], 1)], 1), _vm._v(" "), (_vm.PasswordModal.passNotMatchErr != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passNotMatchErr))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "d-block mr-0 ml-auto",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("Reset")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Select Employee / Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.clientModal.userId != '' ?
        true :
        _vm.UserPersonalDetail.userId == '' ?
        false :
        true,
      "list": _vm.typeList,
      "option-value": "clientTypeV",
      "option-text": "clientTypeT",
      "placeholder": "Select Type "
    },
    model: {
      value: (_vm.UserPersonalDetail.type),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "type", $$v)
      },
      expression: "UserPersonalDetail.type"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.UserPersonalDetail.type == '2') ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.clientModal.userId == '' ? false : true,
      "list": _vm.clientdetail,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client "
    },
    on: {
      "input": _vm.getClient
    },
    model: {
      value: (_vm.clientModal.clientId),
      callback: function($$v) {
        _vm.$set(_vm.clientModal, "clientId", $$v)
      },
      expression: "clientModal.clientId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client Username")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "clientUserName",
      "name": "clientUserName",
      "disabled": ""
    },
    model: {
      value: (_vm.clientModal.clientUserName),
      callback: function($$v) {
        _vm.$set(_vm.clientModal, "clientUserName", $$v)
      },
      expression: "clientModal.clientUserName"
    }
  })], 1), _vm._v(" "), (_vm.clientModal.userId == '') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "clientPass",
      "name": "clientPass",
      "type": "password"
    },
    model: {
      value: (_vm.clientModal.clientPass),
      callback: function($$v) {
        _vm.$set(_vm.clientModal, "clientPass", $$v)
      },
      expression: "clientModal.clientPass"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.clientModal.userId == '') ? _c('md-layout', {
    staticClass: "justify-content-center mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addClientLog
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.type == '1') ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "employeeName",
      "name": "employeeName"
    },
    on: {
      "keyup": _vm.fillUserName
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeName),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeName", $$v)
      },
      expression: "UserPersonalDetail.employeeName"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.employeeName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.employeeName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "employeeCode",
      "name": "employeeCode",
      "disabled": ""
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeCode),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeCode", $$v)
      },
      expression: "UserPersonalDetail.employeeCode"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.employeeCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.employeeCode))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Username")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "clientUserName",
      "name": "clientUserName"
    },
    on: {
      "keyup": _vm.isuserNameValid
    },
    model: {
      value: (_vm.UserPersonalDetail.username),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "username", $$v)
      },
      expression: "UserPersonalDetail.username"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.username) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.username))]) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.username) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroruserFormat))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Mobile No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "mobileNo",
      "name": "mobileNo"
    },
    model: {
      value: (_vm.UserPersonalDetail.mobileNo),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "mobileNo", $$v)
      },
      expression: "UserPersonalDetail.mobileNo"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.mobileNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.mobileNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Landline No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "landLineNo",
      "name": "landLineNo"
    },
    model: {
      value: (_vm.UserPersonalDetail.landLineNo),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "landLineNo", $$v)
      },
      expression: "UserPersonalDetail.landLineNo"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Email-Id")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "email",
      "name": "email"
    },
    on: {
      "keyup": _vm.isEmailValid
    },
    model: {
      value: (_vm.UserPersonalDetail.email),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "email", $$v)
      },
      expression: "UserPersonalDetail.email"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.email))]) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmailFormat))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Designation")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.designationData,
      "option-value": "designation",
      "option-text": "designation",
      "placeholder": "Select Employee Designation"
    },
    model: {
      value: (_vm.UserPersonalDetail.designation),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "designation", $$v)
      },
      expression: "UserPersonalDetail.designation"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.designation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.designation))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Base Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.baseLocationData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select  Location"
    },
    on: {
      "input": _vm.getBillingLocation
    },
    model: {
      value: (_vm.UserPersonalDetail.baseLocation),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "baseLocation", $$v)
      },
      expression: "UserPersonalDetail.baseLocation"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.baseLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.baseLocation))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Billing Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.billingLocationData,
      "option-value": "billingLocationId",
      "option-text": "billingLocation",
      "placeholder": "Select Billing Location"
    },
    model: {
      value: (_vm.UserPersonalDetail.billingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "billingLocationId", $$v)
      },
      expression: "UserPersonalDetail.billingLocationId"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.baseLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.baseLocation))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "MultiBranch"
    }
  }, [_vm._v("Allow Multi-Branch")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.MultiLocationList,
      "selected-options": _vm.items,
      "placeholder": "Select Multi-Branch",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultiBranch
    },
    model: {
      value: (_vm.UserPersonalDetail.multibranch),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "multibranch", $$v)
      },
      expression: "UserPersonalDetail.multibranch"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "MultiPaymentTab"
    }
  }, [_vm._v("Allow Payment Tab")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.MultiPaymentTabList,
      "selected-options": _vm.PaymentTabitems,
      "placeholder": "Select Multi Payment Tab",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultiPaymentTab
    },
    model: {
      value: (_vm.UserPersonalDetail.multiPaymentTab),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "multiPaymentTab", $$v)
      },
      expression: "UserPersonalDetail.multiPaymentTab"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Preference")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Transport Preference")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Transport Preference"
    },
    model: {
      value: (_vm.UserPersonalDetail.transportTypePre),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "transportTypePre", $$v)
      },
      expression: "UserPersonalDetail.transportTypePre"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Preference")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Branch/Client Preference")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.branchClientList,
      "option-value": "BCVal",
      "option-text": "BCText",
      "placeholder": "Select Transport Preference"
    },
    model: {
      value: (_vm.UserPersonalDetail.branchclientPre),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "branchclientPre", $$v)
      },
      expression: "UserPersonalDetail.branchclientPre"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Page View Preference")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pageViewPreferenceList,
      "option-value": "UPVal",
      "option-text": "UPText",
      "placeholder": "Select Page View Preference"
    },
    model: {
      value: (_vm.UserPersonalDetail.user_view_page_pref),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "user_view_page_pref", $$v)
      },
      expression: "UserPersonalDetail.user_view_page_pref"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Preference")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Pendency Dashboard (User Access)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.UserPreferenceList,
      "option-value": "UPVal",
      "option-text": "UPText",
      "placeholder": "Select User Preference"
    },
    model: {
      value: (_vm.UserPersonalDetail.user_pre),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "user_pre", $$v)
      },
      expression: "UserPersonalDetail.user_pre"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Multi Update (User Access)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.MultiUpdatePreferenceList,
      "option-value": "UPVal",
      "option-text": "UPText",
      "placeholder": "Select Multi Update"
    },
    model: {
      value: (_vm.UserPersonalDetail.is_access_multi_update),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "is_access_multi_update", $$v)
      },
      expression: "UserPersonalDetail.is_access_multi_update"
    }
  })], 1)], 1), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Require Validation for Rights")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "name": "ape_rights_require_validation",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.UserPersonalDetail.ape_rights_require_validation),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "ape_rights_require_validation", $$v)
      },
      expression: "UserPersonalDetail.ape_rights_require_validation"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.UserPersonalDetail.ape_rights_require_validation ? 'Yes' : 'No'))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('RightsManagementComponent', {
    ref: "rightsManagement",
    attrs: {
      "userData": _vm.UserPersonalDetail,
      "showSection": _vm.UserPersonalDetail.designation != '',
      "requireValidation": _vm.UserPersonalDetail.ape_rights_require_validation
    },
    on: {
      "rights-data-changed": _vm.handleRightsDataChanged
    }
  }), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('div', {
    staticClass: "mt-3 p-4",
    staticStyle: {
      "background": "#f8f9fa",
      "border": "1px solid #dee2e6",
      "border-radius": "5px"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("User Profile")])], 1)])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Approver Flag")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "id": "approver-flag",
      "name": "approver-flag",
      "value": "Yes",
      "unchecked-value": "No"
    },
    model: {
      value: (_vm.UserPersonalDetail.purchase_approver_flag),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "purchase_approver_flag", $$v)
      },
      expression: "UserPersonalDetail.purchase_approver_flag"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.UserPersonalDetail.purchase_approver_flag == "" || _vm.UserPersonalDetail.purchase_approver_flag == "No" ?
    "No" :
    "Yes") + "\n                    ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Management Dashboard Access")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "Yes",
      "unchecked-value": "No"
    },
    model: {
      value: (_vm.UserPersonalDetail.dashBoardPermission),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "dashBoardPermission", $$v)
      },
      expression: "UserPersonalDetail.dashBoardPermission"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.UserPersonalDetail.dashBoardPermission == "" ?
    "No" :
    _vm.UserPersonalDetail.dashBoardPermission))])], 1)], 1), _vm._v(" "), (
    _vm.UserPersonalDetail.finalPagePermision.indexOf('Analysis_Dashboard') >=
    0
  ) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Growth Access")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "id": "checkbox-2",
      "name": "checkbox-2",
      "value": "Yes",
      "unchecked-value": "No"
    },
    model: {
      value: (_vm.UserPersonalDetail.growthPermission),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "growthPermission", $$v)
      },
      expression: "UserPersonalDetail.growthPermission"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.UserPersonalDetail.growthPermission == "" ?
    "No" :
    _vm.UserPersonalDetail.growthPermission))])], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.UserPersonalDetail.finalPagePermision.indexOf('Request For Quotation') >=
    0
  ) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Maintanence Approval Preference")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "id": "checkbox-3",
      "name": "checkbox-3",
      "value": "Yes",
      "unchecked-value": "No"
    },
    model: {
      value: (_vm.UserPersonalDetail.maint_app_preference),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "maint_app_preference", $$v)
      },
      expression: "UserPersonalDetail.maint_app_preference"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.UserPersonalDetail.maint_app_preference == "" ?
    "No" :
    _vm.UserPersonalDetail.maint_app_preference))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Add Resp Vendor Access")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "id": "checkbox-5",
      "name": "checkbox-5",
      "value": "Yes",
      "unchecked-value": "No"
    },
    model: {
      value: (_vm.UserPersonalDetail.maint_reponse_vendor),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "maint_reponse_vendor", $$v)
      },
      expression: "UserPersonalDetail.maint_reponse_vendor"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.UserPersonalDetail.maint_reponse_vendor == "" ?
    "No" :
    _vm.UserPersonalDetail.maint_reponse_vendor))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('div', {
    staticClass: "mt-3 p-4",
    staticStyle: {
      "background": "whitesmoke"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.UserPersonalDetail.designation != '') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h6', [_c('b-badge', [_vm._v("Department Permissions")])], 1), _vm._v(" "), (_vm.UserPersonalDetail.departmentId1.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.employeeDepartmentErr))]) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('b-row', _vm._l((_vm.showSegmentArrayList), function(segmentNameArray, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "4",
        "md-flex": 30
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.departmentId,
        "name": 'employeeDepartment' + (index + 1),
        "id": 'employeeDepartment' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.employeeDepartmentSelect(segmentNameArray.departmentId, index)
        }
      },
      model: {
        value: (_vm.UserPersonalDetail.employeeDepartment[index]),
        callback: function($$v) {
          _vm.$set(_vm.UserPersonalDetail.employeeDepartment, index, $$v)
        },
        expression: "UserPersonalDetail.employeeDepartment[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.departmentName))])], 1)
  })) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.pagePermision.length > 0) ? _c('div', {
    staticClass: "mt-3 p-4",
    staticStyle: {
      "background": "whitesmoke"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h6', [_c('b-badge', [_vm._v("Specific Page Permissions of selected departments")])], 1)])], 1), _vm._v(" "), _c('div', _vm._l((_vm.UserPersonalDetail.pagePermision), function(segmentNameArray1, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "md-gutter": "",
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('h6', {
      staticClass: "pl-2"
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(segmentNameArray1.departmentName))])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('b-row', _vm._l((segmentNameArray1.pageName), function(segmentNameArray, index1) {
      return _c('b-col', {
        key: index1,
        attrs: {
          "md": "4",
          "md-flex": 50
        }
      }, [_c('md-checkbox', {
        staticClass: "md-primary",
        class: _vm.UserPersonalDetail.finalPagePermision.indexOf(
            segmentNameArray
          ) >= 0 ?
          'md-checked checkedNew' +
          segmentNameArray1.pageId +
          (index1 + 1) :
          'checkedNew' + segmentNameArray1.pageId + (index1 + 1),
        attrs: {
          "md-value": segmentNameArray,
          "name": 'deptMas' + (index1 + 1),
          "id": 'deptMas' + (index1 + 1)
        },
        on: {
          "change": function($event) {
            _vm.employeePageName(
              segmentNameArray,
              index1,
              segmentNameArray1.pageId
            )
          }
        }
      }, [_vm._v(_vm._s(segmentNameArray))])], 1)
    }))], 1)], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.showportloginacc == true) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Port Login Access")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortList,
      "option-value": "portV",
      "option-text": "portT",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.UserPersonalDetail.portLoginAccess),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "portLoginAccess", $$v)
      },
      expression: "UserPersonalDetail.portLoginAccess"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.UserPersonalDetail.designation != 'HOD' &&
    _vm.UserPersonalDetail.designation != 'Admin' &&
    _vm.UserPersonalDetail.designation != '' &&
    _vm.userMasterList.length > 0 &&
    _vm.UserPersonalDetail.departmentId1.length > 0
  ) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v(_vm._s(this.UserPersonalDetail.designation == "manager" ?
    "Employee HOD" :
    "Employee Manager"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.userMasterList,
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": _vm.UserPersonalDetail.designation == 'manager' ?
        'Select HOD' :
        'Select Manager'
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeHODId),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeHODId", $$v)
      },
      expression: "UserPersonalDetail.employeeHODId"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.employeeHODId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.employeeHodError))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.NoteArray == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(_vm.UserPersonalDetail.designation != 'manager') ? _c('h4', {
    staticClass: "error"
  }, [_vm._v("\n                  Note:-You Do Not Have Any Manager For Selected Employee Department..!\n                ")]) : _c('h4', {
    staticClass: "error"
  }, [_vm._v("\n                  Note:-You Do Not Have Any HOD For Selected Manager Department..!\n                ")])])], 1) : _vm._e(), _vm._v(" "), (this.departmentError.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("\n                  Note: Select aleast one permission in this " + _vm._s(_vm.departmentErrorList) + "\n                ")])])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center mt-3"
  }, [_c('h4', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.message.length > 0 ? _vm.error.message : "") + "\n                ")]), _vm._v(" "), _c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "disabled": _vm.NoteArray
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "resetPassword",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.deleteUserPop
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9dcd6b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/userManagement/addUser.vue
// module id = 2723
// module chunks = 0